<template>
    <div class="mainContent">
        <BlurCapImageSkeleton class="leading"
            v-if="loading"/>

        <slot name="leadingItem"/>

        <AdEngine/>

        <div class="feed">
            <FeedSkeleton
                v-if="loading"/>
            
            <slot name="feed"/>

            <div v-view="handleView">
                <FeedSkeleton class="resetMargin"
                    v-if="!reachedBottom"/>
            </div>
        </div>
    </div>
</template>

<script>
    import AdEngine             from '@/components/templates/AdEngine'
    import BlurCapImageSkeleton from '@/components/templates/blurCapImage/BlurCapImageSkeleton'
    import FeedSkeleton         from '@/components/layout/main/FeedSkeleton'

    export default {
        name: 'MainContent',
        components: {
            BlurCapImageSkeleton,
            AdEngine,
            FeedSkeleton
        },
        props: {
            loading: {
                type: Boolean,
                required: true,
            },
            reachedBottom: {
                type: Boolean,
                required: true,
            }
        },
        methods: {
            async handleView(event) {
                if(event.type === 'enter') {
                    this.$emit('handleView')
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .mainContent {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .leading {
        margin: 0 4rem;
        z-index: 1;
    }

    @media all and (max-width: 1440px) {
        .leading {
            margin: 0;
        }
    }
</style>